<template>
  <div class="aside selection">
    <p class="aside-title h3">
      <span class="aside-title__text" v-text="previewLabel"></span>
      <span class="aside-title__icon" aria-hidden="true"></span>
    </p>
    <ul>
      <li v-for="(selection, key) in asideList.selections
        .items" :key="key"
      >
        <a
          v-if="selection.ext"
          :href="selection.link"
          target="_blank"
          rel="noreferrer noopener"
          @click.native="$emit('close'); callGTM({
            event: 'menuClick',
            menuLevel1: externalMenuLabel || previewLabel,
            menuLevel2: selection.title
          })"
        >
          <p class="navigation-subtitle h3" v-text="$t(selection.title)"></p>
        </a>
        <router-link
          v-else
          :to="`${localizedUrl}/${selection.link}`"
          @click.native="$emit('close'); callGTM({
            event: 'menuClick',
            menuLevel1: externalMenuLabel || previewLabel,
            menuLevel2: selection.title
          })"
        >
          <p class="navigation-subtitle h3" v-text="$t(selection.title)"></p>
        </router-link>
      </li>
    </ul>
    <slot></slot>
    <!-- <div class="limited col-12 col-md-6 col-lg-12" v-if="false">
      <strong v-html="$t(nav.watches.limited.title)" class="title"></strong>
      <router-link :to="`${localizedUrl}/${nav.watches.limited.link}`" @click.native="$emit('close')">
        <lazy-image class-name="limited-edition-image" :item="limitedEditionPicture" :sizes="limitedEditionPictureSizes"
          root-margin="0px"></lazy-image>
      </router-link>
    </div> -->
  </div>
</template>
<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'


export default {
  name: 'AsideLinks',
  props: {
    previewLabel: {
      type: String,
      default: ''
    },
    externalMenuLabel: {
      type: String,
      default: ''
    },
    asideList: {
      type: Object,
      required: true
    }
  },
  computed: {
    localizedUrl () {
      return currentStoreView().url || ''
    }
  },
  methods: {
    callGTM (gtmObject) {
      if (gtmObject && gtmObject.event) {
        this.$gtm.trackEvent(gtmObject)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/core';

.aside {
  border-right: 0.1rem solid var(--_zenith-color-transparent);

  &-title {
    color: var(--_zenith-header-text-link);
    font-size: 1.8rem;
    line-height: 1.2;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2.5rem;
    margin-bottom: 2.5rem;
    border-bottom: 0.1rem solid var(--_zenith-color-transparent);

    &__icon {
      --icon-size: 1.2rem;
      margin-right: 0.9rem;
      transform: rotate(-45deg);
      width: var(--icon-size);
      height: var(--icon-size);
      border: solid var(--_zenith-header-text-link);
      border-width: 0 0.15rem 0.15rem 0;
    }

    @include bp(max md) {
      display: none;
    }
  }

  .title {
    display: block;
    margin-bottom: 2rem;
    text-transform: uppercase;
    letter-spacing: em(1.75);
    color: var(--_zenith-header-text-link);
  }

  ul {
    margin: 0 0 3rem;
    padding: 0;
    list-style: none;

    li {
      margin-bottom: 2.5rem;

      @include bp(max md) {
        margin-bottom: 0;
      }
    }

    a {
      position: relative;
      display: inline-block;

      @include bp(max md) {
        border-block: 1px solid var(--_zenith-color-transparent);
        width: 100%;
        padding-block: 2.5rem;
      }

      &::before {
        position: absolute;
        content: "";
        display: block;
        height: .1rem;
        width: 0;
        background: var(--_zenith-header-text-link);
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        transition: all .2s ease-in-out;
      }

      &:hover,
      &:focus {
        &::before {
          width: 100%;
        }
      }
    }

    .navigation-subtitle {
      margin: 0;
      color: var(--_zenith-header-text-link);
      text-transform: uppercase;
      letter-spacing: em(1.75);
      font-size: inherit;
      font-weight: inherit;

      @include bp(max md) {
        display: block;
        position: relative;
        text-align: left;
        width: 100%;
        margin: 0;
        text-transform: uppercase;
        border: none;
      }
    }
  }
}
</style>
